import { createSlice } from "@reduxjs/toolkit";

const topLoader = createSlice({
  name: "topLoader",
  initialState: {
    loading: false,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setLoading } = topLoader.actions;
export const loaderData = (state) => state?.topLoader?.loading;
export default topLoader.reducer;
